import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Menu extends Component {

    render() {
        return (
            // <div id="wrapper-toggle-menu">
            //     <div id="sidebar-wrapper">
            //         <ul className="sidebar-nav">
            //             <li className="active">
            //                 <a href="#">Haz</a>
            //             </li>
            //             <li>
            //                 <a href="#">Halal</a>
            //             </li>
            //             <li>
            //                 <a href="#">Trip Northern</a>
            //             </li>
            //             <li>
            //                 <a href="#">CMALL</a>
            //             </li>
            //         </ul>
            //     </div>
            //     <div id="page-content-wrapper">
            //         <a href="#menu-toggle" className="btn btn-default menu-toggle-btn" id="menu-toggle">
            //             <img src="/resources/images/toggle-menu-icon.png" alt="" />
            //         </a>
            //     </div>
            // </div>
            <div className="col-lg-2 col-md-12 navbar-light bg-menu">
                <ul className="nav flex-column">
                    <li className="nav-item navbar-link active">
                        <Link to={'/'}>A-POS</Link>
                    </li>
                    {/* <li className="nav-item navbar-link">
                        <a href="">Halal</a>
                    </li>
                    <li className="nav-item navbar-link">
                        <a href="">Trip Northern</a>
                    </li>
                    <li className="nav-item navbar-link">
                        <a href="">CMALL</a>
                    </li> */}
                </ul>
            </div>
        );
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/views/menu/index.jsx